module.exports = __webpack_public_path__ + "static/media/whatsapp1.bab80c09.svg";